module.exports = __webpack_public_path__ + "img/ao.68ec4c4.png";